import React from 'react';
import dynamic from 'next/dynamic';
import DealsPlaceholder from '@/components/v2/carousels/Deals/Placeholder';
import Section from '../commons/Section';

const Deals = dynamic(() => import('@/components/v2/carousels/Deals'), {
  ssr: false,
  loading: () => <DealsPlaceholder />,
});

const PopularCategories = dynamic(
  () => import('@/components/commons/PopularCategories'),
  {
    ssr: false,
    // Rendered height of the carousel, measured per breakpoint
    loading: () => <div className="min-h-[232px] lg:min-h-[260px]" />,
  },
);

const RecentlyViewed = dynamic(
  () => import('@/components/homepage/RecentlyViewed'),
  { ssr: false },
);

function AccountRecommendations() {
  return (
    <Section className="border border-t-2 border-gray-100 bg-white">
      <Deals />
      <div className="reebelo-container">
        <RecentlyViewed />
        <PopularCategories />
      </div>
    </Section>
  );
}

export default AccountRecommendations;
